import AdminLayout from '../Layouts/AdminLayout';
import AdminDashboard from '../views/Admin/AdminDashboard';
import Users from '../views/Admin/Users';
import User from '../views/Admin/User';
import Trips from '../views/Admin/Trips';
import OdometerLogs from '../views/Admin/OdometerLogs';
import Vehicles from '../views/Admin/Vehicles';
import Refills from '../views/Admin/Refills';

const adminRoutes = [
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      layout: AdminLayout,
      role: 'admin',
      title: 'Admin Panel'
    }
  },
  {
    path: '/admin/users',
    name: 'Users',
    component: Users,
    meta: {
      layout: AdminLayout,
      role: 'admin',
      title: 'Users'
    }
  },
  {
    path: '/admin/users/:id',
    name: 'UserView',
    component: User,
    meta: {
      layout: AdminLayout,
      role: 'admin',
      title: 'User'
    }
  },
  {
    path: '/admin/vehicle/:id/trips',
    name: 'TripsView',
    component: Trips,
    meta: {
      layout: AdminLayout,
      role: 'admin',
      title: 'Vehicle Trips and Tags'
    }
  },
  {
    path: '/admin/vehicle/:id/odometerlogs',
    name: 'OdometerLogsView',
    component: OdometerLogs,
    meta: {
      layout: AdminLayout,
      role: 'admin',
      title: 'Vehicle Odometer Logs'
    }
  },
  {
    path: '/admin/vehicle/:id/refills',
    name: 'RefillsView',
    component: Refills,
    meta: {
      layout: AdminLayout,
      role: 'admin',
      title: 'Vehicle Refills'
    }
  },
	{
    path: '/admin/user/:id/vehicles',
    name: 'VehiclesView',
    component: Vehicles,
    meta: {
      layout: AdminLayout,
      role: 'admin',
      title: 'Vehicles'
    }
  }
];

export default adminRoutes;
